<template>
  <div>
    <!-- PC -->
    <div class="banner" v-if="isPcFlag" :style="{ background: `url(${pcBgImg}) center center / cover no-repeat` }">
      <div class="banner-info" v-if="haveTheFormFlag">
        <div class="title">
          <p class="banner-title" v-if="bannerTitle">{{ bannerTitle }}</p>
          <div class="banner-desc" v-if="bannerDesc">{{ bannerDesc }}</div>
        </div>
        <Form
          class="banner-form"
          @setShowSuccessDialog="setShowSuccessDialog"
          @msg="msg => $emit('msg', msg)"
          :landingPageName="landingPageName"
        />
      </div>
      <div class="con" v-else>
        <img class="logo" src="../assets/images/logo.png" alt="" v-if="logoFlag" />
        <div class="text">
          <h1 class="title">{{ pcTitle }}</h1>
          <h6 class="des" v-if="pcDesc">
            {{ pcDesc }}
          </h6>
          <h6 class="des" v-if="pcSecondDesc">
            {{ pcSecondDesc }}
          </h6>
          <div class="btns">
            <div v-if="pcBtntext" class="btn" @click="showQrCodeDialog">{{ pcBtntext }}</div>
            <div v-if="pcBtndesc" class="btn" @click="showDialog">{{ pcBtndesc }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- h5 -->
    <div class="banner-mobile" v-else>
      <img class="img" :src="h5BgImg" alt="" />
      <div class="con">
        <div class="title">
          <p class="first-line" v-if="h5Title">{{ h5Title }}</p>
          <div class="second-line" v-if="h5TitleSecond">{{ h5TitleSecond }}</div>
        </div>
        <div class="des">{{ h5Desc }}</div>
        <div class="btns">
          <div v-if="h5Btntext" class="btn" @click="showQrCodeDialog">{{ h5Btntext }}</div>
          <div v-if="h5Btndesc" class="btn" @click="showDialog">{{ h5Btndesc }}</div>
          <div v-if="h5signetBtn" class="btn" @click="showSignetDialog">
            {{ h5signetBtn }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    pcBgImg: {
      // banner背景图
      type: String,
      default: '',
    },
    haveTheFormFlag: {
      // 是否有表单
      type: Boolean,
      default: false,
    },
    bannerTitle: {
      // 有表单的情况，banner上面左侧最大的标题
      type: String,
      default: '',
    },
    bannerDesc: {
      // 有表单的情况，banner上面左侧描述
      type: String,
      default: '',
    },
    logoFlag: {
      // 有表单的情况，是否有左上角有“e签宝”的logo

      type: Boolean,
      default: false,
    },
    pcTitle: {
      // 无表单的情况，banner上面左侧最大的标题
      type: String,
      default: '',
    },
    pcDesc: {
      // 无表单的情况，banner上面左侧第一行描述
      type: String,
      default: '',
    },
    pcSecondDesc: {
      // 无表单的情况，banner上面左侧第一行描述
      type: String,
      default: '',
    },
    pcBtntext: {
      // 无表单的情况，banner上面左侧第一按钮
      type: String,
      default: '',
    },
    pcBtndesc: {
      // 无表单的情况，banner上面左侧第二个按钮
      type: String,
      default: '',
    },

    h5Title: {
      // h5最大的标题
      type: String,
      default: '',
    },
    h5TitleSecond: {
      // h5最大的标题第二行
      type: String,
      default: '',
    },

    h5Desc: {
      // h5最大的标题下面的描述
      type: String,
      default: '',
    },
    h5BgImg: {
      // h5的背景图
      type: String,
      default: '',
    },
    h5Btntext: {
      // h5按钮，ofd落地页上，控制显示二维码弹框按钮的文案
      type: String,
      default: '',
    },
    h5Btndesc: {
      // h5按钮，ofd落地页上，控制显示留资弹框按钮的文案
      type: String,
      default: '',
    },
    h5signetBtn: {
      // h5按钮，思格特印控仪上，控制显示留资弹框按钮的文案
      type: String,
      default: '',
    },

    landingPageName: {
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      type: String,
      default: '',
    },
  },
  components: {
    Form: () => import('./Form.vue'),
  },
  methods: {
    // 留资弹框
    showDialog() {
      this.$emit('showDialog')
    },
    // 二维码弹框
    showQrCodeDialog() {
      this.$emit('showQrCodeDialog')
    },
    setShowSuccessDialog(v) {
      this.$emit('setShowSuccessDialog', v)
    },
    // 印控仪H5弹框
    showSignetDialog() {
      this.$emit('showSignetDialog')
    },
  },
}
</script>
<style lang="less" scoped>
// PC样式
.banner {
  width: 100%;
  height: 560px;
  padding: 0 5%;
  background-color: #edeef3;
  .banner-info {
    max-width: 1320px;
    height: 100%;
    margin: 0 auto;
    position: relative;

    .title {
      position: absolute;
      left: 0;
      top: 98px;
      .banner-title {
        font-size: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 20px;
      }
      .banner-desc {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .banner-form {
      position: absolute;
      right: 120px;
      top: 76px;
    }
  }
  .con {
    position: relative;
    max-width: 1320px;
    height: 560px;
    margin: 0 auto;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    .logo {
      width: 121px;
      height: 33px;
      position: absolute;
      left: 0;
      top: 46px;
    }
    .text {
      .title {
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 56px;
        margin-bottom: 20px;
      }
      .des {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: normal;
        color: #202640;
        line-height: 30px;
      }
      .btns {
        display: flex;
        & > div:nth-child(2) {
          margin-left: 50px;
        }
        .btn {
          margin-top: 39px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          height: 40px;
          background-color: #e61717;
          color: #fff;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          border-radius: 4px;
        }
      }
    }
  }
}
// H5样式
.banner-mobile {
  width: 100%;
  height: 100%;
  .img {
    width: 100%;
    height: 100%;
  }
  .con {
    .title {
      font-size: 0.65rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1.0667rem;
      text-align: center;
      margin-bottom: 0.2667rem;
    }
    .des {
      font-size: 0.3733rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 0.5333rem;
      letter-spacing: 1px;
      text-align: center;
      margin-bottom: 1.0667rem;
    }
    .btns {
      display: flex;
      justify-content: center;
      margin-top: 3.3333rem;
      & > div:nth-child(2) {
        margin-left: 0.8533rem;
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3.2rem;
        height: 0.8533rem;
        background-color: #e63740;
        color: #fff;
        font-size: 0.3733rem;
        font-family: PingFangSC-Regular, PingFang SC;
        border-radius: 4px;
      }
    }
  }
}
.fadeInUp {
  visibility: visible;
  animation-delay: 150ms;
  animation-name: fadeInUp;
}

@-webkit-keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
